import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography/Typography";
import PropTypes from "prop-types";
import CustomDialog from "../Shared/Components/CustomDialog";
import MainButton from "../Shared/Components/MainButton";
import { useSelector } from "react-redux";
import Api from "../core/Api";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import qs from "qs";
import get from "lodash/get";

export const baseUrl = `${process.env.REACT_APP_HOST}`;

const useStyles = makeStyles((theme) => ({
  dialogTitleRoot: {
    padding: "12px 12px 20px",
    fontSize: "1.5rem",
    fontWeight: 400,
  },
  dialogContentRoot: {
    padding: "0 24px 24px 12px",
  },
  activeButton: {
    textTransform: "none",
    whiteSpace: "nowrap",
    padding: "4px 15px",
    color: "white",
    textDecoration: "none",
    "&:hover": {
      opacity: 0.6,
    },
    "&.Mui-disabled": {
      opacity: 0.2,
      "&:hover": {
        opacity: 0.2,
      },
    }
  },
  activeButtonLabel: {
    color: "white",
  },
  TypographyCaption: {
    fontSize: 12,
    lineHeight: 1.7,
  },
}));
const PdfDownload = (props) => {
  const { show, onClose } = props;
  const classes = useStyles(props);
  const { t } = useTranslation("pdfDownload");
  const { configuration } = useSelector((state) => state.Configuration);
  const { token } = useSelector((state) => state.User);

  const createPdfUrl = (documentType = "user") => {
    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
    let client = queryParams.client ? queryParams.client : queryParams._client;

    if (client === "regalwerk" || client === undefined) {
      client = '_default';
    }

    const params = Api.getGETParameters();
    params["shop-user-token"] = token;
    params['_client'] = client;
    console.log(params);
    const queryString = Object.keys(params)
      .filter(
        (key) => ["_language", "_channel", "shop-user-token", "_client", "_share_url"].indexOf(key) !== -1
      )
      .map((key) => key + "=" + params[key])
      .join("&");
    return `${baseUrl}/frontendapi/configurations/pdf/${documentType}/${configuration.code}?${queryString}`;
  };

  return (
    <CustomDialog
      open={show}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      dialogTitle={t("pdfDownload:yourConfiguration")}
      onCancel={onClose}
    >
      <DialogContent className={classes.dialogContentRoot}>
        <Typography
          variant="body1"
          classes={{ root: classes.TypographyCaption }}
          id="alert-dialog-description"
        >
          {t("readyToDownloadText")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <MainButton
          onClick={() => window.open(createPdfUrl("user"))}
          disabled={!!!get(configuration, 'code')}
          variant="contained"
          classes={{
            root: clsx(classes.activeButton, "primaryButton"),
            label: classes.activeButtonLabel,
          }}
        >
          {t("downloadNow")}
        </MainButton>
      </DialogActions>
    </CustomDialog>
  );
};
PdfDownload.propTypes = {
  classes: PropTypes.object,
  onClose: PropTypes.func,
  show: PropTypes.bool,
};
export default PdfDownload;
